import { useCallback, useEffect, useRef } from "react";

import { getPositionIcon } from "../utils/getMapIcon";
import getUserPosition from "../utils/getUserPosition";

type TUserPositionReturn = {
  updateUserPosition: () => void;
};

const useUserPosition = (map?: H.Map, selectedLockerId?: string, hasPositionInit = true): TUserPositionReturn => {
  const positionMarkerRef = useRef<H.map.Marker>();

  const updateUserPosition = useCallback(async () => {
    if (!map) {
      return;
    }
    if (positionMarkerRef.current) {
      positionMarkerRef.current.setVisibility(false);
    }

    const position = await getUserPosition();

    if (!position) {
      return;
    }

    if (!positionMarkerRef.current) {
      positionMarkerRef.current = new H.map.Marker(position, {
        icon: getPositionIcon(),
      });
      map.addObject(positionMarkerRef.current);
    }

    positionMarkerRef.current.setGeometry(position);
    positionMarkerRef.current.setVisibility(true);

    map.getViewModel().setLookAtData({ position, zoom: 15 }, true);
  }, [map]);

  // If no locker selected - automatically request user's position and center map on that
  useEffect(() => {
    if (map && !selectedLockerId && hasPositionInit) {
      updateUserPosition();
    }
  }, [map, selectedLockerId, updateUserPosition, hasPositionInit]);

  return { updateUserPosition };
};
export default useUserPosition;
